import { Injectable } from '@angular/core';
import { ApiServiceBase } from './api.service.base';
import { Observable } from 'rxjs';
import { DownloadJobModel, DownloadJobQueueResponse } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class DownloadJobService extends ApiServiceBase {
  public queueDownload(
    projectId: number,
    postId: number,
    request: { includedFileTypes: number[] }
  ): Observable<DownloadJobQueueResponse> {
    return this.post(`project/${projectId}/post/${postId}/download`, request);
  }

  public getUserDownloadJobs(limit: number = 10): Observable<DownloadJobModel[]> {
    return this.get('download-jobs', { params: { limit: limit.toString() } });
  }

  public getDownloadJob(jobId: string): Observable<DownloadJobModel> {
    return this.get(`download-jobs/${jobId}`);
  }

  public downloadFile(jobId: string): void {
    // This will trigger a redirect to the SAS URL
    window.open(this.buildUrl(`download-jobs/${jobId}/download`), '_blank');
  }

  public deleteDownloadJob(jobId: string): Observable<void> {
    return this.delete(`download-jobs/${jobId}`);
  }
}
